import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, map, of, tap } from 'rxjs';

export interface SessionUser {
  idUsuario: number;
  nombreCompleto: string;
  idRol: number;
  idEmpresa?: number;
  idEmpresaActiva?: number;
  idSector?: number;
  nombreEmpresa?: string;
  nombreEmpresaActiva?: string;
  puedeModificar?: boolean;
}

export interface EmpresaOption {
  idEmpresa: number;
  nombre: string;
}

@Injectable({ providedIn: 'root' })
export class AuthService {
  readonly user = signal<SessionUser | null>(null);

  constructor(
    private readonly http: HttpClient,
    private readonly router: Router
  ) {}

  login(cedula: string, contrasena: string): Observable<SessionUser> {
    return this.http.post<SessionUser>('/webapi/auth/login', { cedula, contrasena })
      .pipe(tap((user) => this.user.set(user)));
  }

  loadSession(): Observable<SessionUser | null> {
    return this.http.get<SessionUser>('/webapi/auth/me').pipe(
      tap((user) => this.user.set(user)),
      catchError(() => {
        this.user.set(null);
        return of(null);
      })
    );
  }

  logout(): void {
    this.http.post('/webapi/auth/logout', {}).subscribe({
      complete: () => {
        this.user.set(null);
        void this.router.navigateByUrl('/login');
      }
    });
  }

  empresasDisponibles(): Observable<EmpresaOption[]> {
    return this.http.get<{ codigo: number; respuesta: EmpresaOption[] }>('/webapi/auth/empresas')
      .pipe(
        map((response) => Array.isArray(response.respuesta) ? response.respuesta : []),
        catchError(() => of([]))
      );
  }

  cambiarEmpresaActiva(empresa: EmpresaOption): Observable<SessionUser> {
    return this.http.post<SessionUser>('/webapi/auth/empresa-activa', {
      idEmpresa: empresa.idEmpresa,
      nombreEmpresa: empresa.nombre
    }).pipe(tap((user) => this.user.set(user)));
  }
}
